import * as React from 'react';
import * as styles from './quote.css';

const quote = require('../../../../assets/svg/quote.svg') as string;

export const Quote: React.SFC<{}> = () => {
  return (
    <section className={styles.quoteContainer}>
      <div className={styles.content}>
        <div className={styles.symbol}>
          <img src={quote} />
        </div>
        <div className={styles.quote}>
          Diversity is at the very core of our ability to serve our clients well and to maximize
          return for our shareholders. Diversity supports and strengthens the firm's culture, and it
          reinforces our reputation as the employer of choice in our our industry and beyond.
          <p>
            Lloyd C. Blankfein, Chairman and Chief Executive Officer, The Goldman Sachs Group, Inc.
          </p>
        </div>
      </div>
    </section>
  );
};
